module.exports = __webpack_public_path__ + "img/Instagram-icon.1ae6e645.png";